import { useCallback } from 'preact/hooks';
import { useDispatch } from 'react-redux';

import { useStore } from '@/redux/helper';

import openSpeedyFlow from '../openSpeedyFlow';
import { GateRequirement } from '../types';

/**
 * Component-facing wrapper around `openSpeedyFlow`.
 *
 * Reads the store lazily at click time rather than subscribing to it: a trigger site only needs the
 * user's state at the moment it fires, and subscribing would re-render every consumer on any user
 * change — which is also how an earlier version ended up re-opening and resetting a running flow.
 */
const useOpenSpeedyFlow = () => {
  const dispatch = useDispatch();
  const store = useStore();

  return useCallback(
    (gate: GateRequirement, onSatisfied?: () => void) => openSpeedyFlow(store.getState(), dispatch, gate, onSatisfied),
    [dispatch, store],
  );
};

export default useOpenSpeedyFlow;
